import { Component } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';

import { filter } from 'rxjs/operators';

import { BrandingService, ThemeService } from '@library/common/branding';
import { HttpPagination } from '@library/common/http';
import {
   BrowserCheckService,
   BreakpointService,
   EnvironmentService,
   GoogleAnalyticsService,
} from '@library/core/services';

import { environment } from './http/environment';

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent {
   constructor(
      private breakpoints: BreakpointService,
      private check: BrowserCheckService,
      private gtag: GoogleAnalyticsService,
      private router: Router,
      private brand: BrandingService,

      public theme: ThemeService,
      public e: EnvironmentService,
      private pagination: HttpPagination,
   ) {
      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();

      this.brand.load();

      this.router.events.pipe(
         filter( _ => environment.production ),
         filter( event => event instanceof NavigationEnd ),
      ).subscribe(( event: NavigationEnd ) => {
         ( window as any ).gtag('config', 'UA-117424204-9', { page_path: event.urlAfterRedirects });
      });

      this.router.events.subscribe( event => {
         if ( event instanceof NavigationStart ) {
            this.pagination.stop(); // Stop background pagination to allow resumption
         }
      });
   }
}
